import { Platform, ProjectName } from 'experimentation-client-js';

import { getLanguage } from 'api/utils/languageManagment';

import { store } from 'store/configureStore';
import { selectCurrentUser } from 'store/user/selectors';

import { PLATFORM_BY_KEY } from 'constants/api';
import { SOURCE } from 'constants/general';

import { getAgeFromBirthday, toYYMMDD } from 'helpers/date';
import { getDeviceType, getEmailDomain } from 'helpers/utils';

import type { DefaultState } from './types';

let defaultState: DefaultState = null;

export const getDefaultState = (): DefaultState => defaultState;

export const setEppoDefaultAttributes = (): void => {
    const state = store.getState();

    const {
        gender,
        created_at,
        is_active_plan,
        problem_zones,
        fitness_level,
        weight,
        height,
        goal,
        target_weight,
        payment_platform,
        reteno_contact_id,
        country,
        user_id,
        date_of_birth,
        first_login_at,
        units,
        nps_group,
        email,
        w2a_branch,
    } = selectCurrentUser(state);

    if (!user_id) return;

    defaultState = {
        subjectId: String(user_id),
        stableId: String(user_id),
        attrs: {
            // Application info
            platform: Platform.WEB,
            source: SOURCE,
            source_platform: Platform.WEB,
            source_project: ProjectName.YOGA,

            // User properties
            age: getAgeFromBirthday(date_of_birth),
            gender: gender,
            ...(created_at && { created_at: created_at }),
            ...(created_at && { created_at_date: toYYMMDD(created_at) }),

            ...(first_login_at && { first_login_at: first_login_at }),
            ...(first_login_at && { first_login_at_date: toYYMMDD(first_login_at) }),

            ...(is_active_plan !== undefined && { is_active_plan: is_active_plan }),

            // Fitness specific
            problem_zones: problem_zones,
            fitness_level: fitness_level,
            weight: weight,
            height: height,
            scale: units,
            goal: goal,
            target_weight: target_weight,

            // Other attributes
            ...(nps_group && { nps_group: nps_group }),
            ...(payment_platform && { payment_platform: PLATFORM_BY_KEY[payment_platform]?.toUpperCase() }),
            ...(reteno_contact_id && { reteno_contact_id: reteno_contact_id }),
            country: country,
            device_type: getDeviceType(),
            language: getLanguage(),
            email_domain: getEmailDomain(email),
            w2a_branch,
        },
    };
};
